/* eslint-disable max-len -- Keep localized catalogue sentences together. */
export const validApproval = (approval) =>
  approval?.status === 'approved' &&
  typeof approval.operator?.displayName === 'string' &&
  !!approval.operator.displayName.trim() &&
  typeof approval.operator?.email === 'string' &&
  /^[^\s@?&#:]+@[^\s@?&#:]+\.[^\s@?&#:]+$/.test(approval.operator.email);

export const resumeLabels = {
  en: {
    originalApproval: 'Original approval',
    moveDomain: 'THIS ORIGINAL MOVE',
    currentDomain: 'SUBSCRIPTION NOW',
    lastDomain: 'SUBSCRIPTION · LAST CONFIRMED',
    missingTerm: 'Unavailable',
    operations: 'Separate operational controls',
    safeguards: 'Move safeguards · until completion',
    operation: 'Operation',
    now: 'Now',
    lastCheck: 'At last check',
    afterFinish: 'After Finish',
    notPaused: 'Not paused',
    changeFromFinish: 'Change from Finish',
    none: 'None',
    operationalControls: 'Operational controls',
    unchanged: 'Unchanged',

    subscription: 'Subscription',
    original: 'Original move',
    approved: '✓ Approved',
    approver: 'Original approver',
    title: 'Original move to active-access billing',
    billing: 'Access billing',
    lastBilling: 'Last confirmed access billing',
    notStarted: 'Not started',
    access: 'Your access to this move',
    lastTerm: 'Last confirmed current term end',
    lastNeeded: 'Needed at last check',
    lastCovered: '✓ Capacity covered at last check',
    details: 'Original move details',
    moveCharge: 'Move charge',
    purchases: 'Purchases unchanged',
    finish: 'Finish original move',
    completion: 'Move completion',
    pending: 'Not recorded',
    unknown: 'Not confirmed',
    completed: 'Completed',
    blocked: 'Original approver required',
    unauthenticated: 'Sign in required',
    denied: 'Denied',
    unavailable: 'Approval unavailable',
    afterMove: 'Starts when the move completes',
    active: 'Active',
    rates: 'Original move rates per purchased seat',
    resume: 'Resume original move',
    refresh: 'Refresh status',
    waiting: 'Waiting for response',
    request: 'Your request',
    email: 'Email',
  },
  ar: {
    originalApproval: 'الموافقة الأصلية',
    moveDomain: 'هذا الانتقال الأصلي',
    currentDomain: 'الاشتراك الآن',
    lastDomain: 'الاشتراك · آخر حالة مؤكدة',
    missingTerm: 'غير متاح',
    operations: 'ضوابط التشغيل المستقلة',
    safeguards: 'حماية الانتقال · حتى اكتماله',
    operation: 'العملية',
    now: 'الآن',
    lastCheck: 'عند آخر تحقق',
    afterFinish: 'بعد الإكمال',
    notPaused: 'غير متوقف',
    changeFromFinish: 'التغيير عند الإكمال',
    none: 'لا تغيير',
    operationalControls: 'ضوابط التشغيل',
    unchanged: 'دون تغيير',

    subscription: 'الاشتراك',
    original: 'الانتقال الأصلي',
    approved: '✓ معتمد',
    approver: 'المعتمد الأصلي',
    title: 'الانتقال الأصلي إلى فوترة الوصول النشط',
    billing: 'فوترة الوصول',
    lastBilling: 'آخر حالة مؤكدة لفوترة الوصول',
    notStarted: 'لم تبدأ',
    access: 'صلاحيتك لهذا الانتقال',
    lastTerm: 'نهاية الفترة عند آخر تحقق',
    lastNeeded: 'المطلوب عند آخر تحقق',
    lastCovered: '✓ السعة كافية عند آخر تحقق',
    details: 'تفاصيل الانتقال الأصلي',
    moveCharge: 'تكلفة الانتقال',
    purchases: 'المشتريات دون تغيير',
    finish: 'إكمال الانتقال الأصلي',
    completion: 'اكتمال الانتقال',
    pending: 'غير مسجل',
    unknown: 'غير مؤكد',
    completed: 'مكتمل',
    blocked: 'يلزم المعتمد الأصلي',
    unauthenticated: 'يلزم تسجيل الدخول',
    denied: 'مرفوضة',
    unavailable: 'الموافقة غير متاحة',
    afterMove: 'تبدأ عند اكتمال الانتقال',
    active: 'مفعّلة',
    rates: 'أسعار الانتقال الأصلي لكل مقعد مشترى',
    resume: 'استئناف الانتقال الأصلي',
    refresh: 'تحديث الحالة',
    waiting: 'بانتظار الرد',
    request: 'طلبك',
    email: 'مراسلة',
  },
};
